<template>
  <div></div>
</template>

<script>
import alertsMixin from '../mixins/alerts-mixin'

export default {
  name: 'AlertsHandler',
  mixins: [alertsMixin],
  mounted () {
    this.unsubscribe = this.$store.subscribe(mutation => {
      if (mutation.type === 'SHOW_ALERT') {
        const { type, message } = mutation.payload
        switch (type) {
          case 'success':
            return this.alertSuccess(message)
          case 'warn':
            return this.alertWarning(message)
          case 'error':
            return this.alertError(message)
          default:
            return this.alertInfo(message)
        }
      }
    })
  },
  beforeDestroy () {
    this.unsubscribe()
  }
}
</script>

<style>
.notifications, .vue-notification-group { margin-top: 50px; }
</style>
